export default "__VITE_ASSET__Bh0grBhx__"